export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_09.ab8f8602.jpg";